import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ServerRoutes } from "src/app/ServerRoutes";

@Injectable({
	providedIn: "root",
})
export class AuthService {
	constructor(private http: HttpClient, private routes: ServerRoutes) {}

	newUser(user) {
		return this.http.post(this.routes.newUser, user);
	}

	login(user) {
		return this.http.post(this.routes.login, user);
	}

	uploadPerfilProfissional(perfilProfissional) {
		return this.http.post(
			this.routes.uploadPerfilProfissional,
			perfilProfissional
		);
	}

	uploadDocumento(documento) {
		return this.http.post(this.routes.uploadDocumento, documento);
	}

	uploadCRP(crp) {
		return this.http.post(this.routes.uploadCRP, crp);
	}
}
